import { createContext, useContext, useState, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

const KioskContext = createContext(null);

// Las dos tablets del stand comparten el check-in y la ficha del núcleo, y se
// separan recién al final (gemelos §5.1: "antes de esta pantalla siempre pasa
// el check-in del núcleo compartido").
const FLUJOS = {
  // El destino de la ruleta ya no es el giro sino el paso de caravana:
  // esa pantalla decide sola si mostrarse y después manda a girar.
  RULETA: { base: '/kiosk', ficha: '/kiosk/ficha', destino: '/kiosk/caravana' },
  ENTREGA: { base: '/entrega', ficha: '/entrega/ficha', destino: '/entrega/caravana' },
};

export function KioskProvider({ children, flujo = 'RULETA' }) {
  const [attendee, setAttendee] = useState(null);
  const [phoneRaw, setPhoneRaw] = useState('');
  // Lo que la persona tipeó en el check-in, para no pedírselo dos veces.
  const [tagRaw, setTagRaw] = useState('');
  const [spinResult, setSpinResult] = useState(null);
  const [isSpinning, setIsSpinning] = useState(false);
  // A dónde va la persona DESPUÉS del paso de caravana. Normalmente el
  // giro; /kiosk/premio si el check-in detectó que ya giró hoy.
  const [destinoFinal, setDestinoFinal] = useState(null);
  const navigate = useNavigate();

  const rutas = useMemo(() => FLUJOS[flujo] || FLUJOS.RULETA, [flujo]);

  const reset = useCallback(() => {
    setAttendee(null);
    setPhoneRaw('');
    setTagRaw('');
    setSpinResult(null);
    setIsSpinning(false);
    setDestinoFinal(null);
    navigate(rutas.base, { replace: true });
  }, [navigate, rutas.base]);

  return (
    <KioskContext.Provider value={{
      flujo, rutas,
      attendee, setAttendee,
      phoneRaw, setPhoneRaw,
      tagRaw, setTagRaw,
      spinResult, setSpinResult,
      isSpinning, setIsSpinning,
      destinoFinal, setDestinoFinal,
      reset,
    }}>
      {children}
    </KioskContext.Provider>
  );
}

export const useKiosk = () => {
  const ctx = useContext(KioskContext);
  if (!ctx) throw new Error('useKiosk fuera de KioskProvider');
  return ctx;
};
